import Phaser from 'phaser'
import { HOME_SOUNDS } from '../constants/assets-constants'

export default class GameSounds {
  /** @type Phaser.GameObjects.Image */
  Sounds = {}

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {
    for (let name in HOME_SOUNDS) {
      let url = HOME_SOUNDS[name]
      this.sceneContext.load.audio(`${name}`, url)
    }
  }

  create() {
    for (let name in HOME_SOUNDS) {
      this.Sounds = {
        ...this.Sounds,
        [name]: this.sceneContext.sound.add(name),
      }
    }
  }
}
